<template>
  <div class="stores">
    <div style="padding: 10px 0">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>课程管理</el-breadcrumb-item>
        <el-breadcrumb-item>训练计划</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hall-search-list">
      <el-button
        v-has="'course_list_add'"
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="add"
        plain
        >创建训练计划</el-button
      >
			<span class="hall-search-name">运动类型:</span>
			<el-select v-model="sportsKindId" placeholder="请选择" @change="init">
          <el-option  v-for="item in selData" :key="item.val" :label="item.name" :value="item.val"></el-option>
      </el-select>
      <span class="hall-search-name">运动目标:</span>
			<el-select v-model="targetId" placeholder="请选择" @change="init">
          <el-option  v-for="item in selData1" :key="item.val" :label="item.name" :value="item.val"></el-option>
      </el-select>
		</div>
    <!-- 列表 -->
    <div class="main">
      <template>
        <div class="traingplan">
          <dl v-for="(item, index) in tableData" :key="index" class="traingplan-group">
            <!-- <dt><router-link :to="{path:'/addTrainingPlan', query: {id:item.id}}"><img :src="item.coverUrl" /></router-link></dt> -->
            <dt>
              <!-- <router-link :to="{path:'/addTrainingPlan', query: {id:item.id}}"> -->
              <div class="traingplan-img-group">
                <img :src="item.cover" />
                <div class="traingplan-hover" @click="addTrainingPlan(item.id)">查看详情</div>
              </div>
              <!-- </router-link> -->
              <p class="title">名称：{{item.name}}</p>
              <p class="title title_bewteen">
                <span>运动类型：{{item.sportsKindName}}</span>
                <span>目标：{{item.targetId | targetIdName(modelList.targetId.optionList)}}</span>
              </p>
              <p class="title title_bewteen">
                <span>周期：{{item.trainingCycle | trainingCycleName(modelList.trainingCycle.optionList)}}</span>
                <span>频次：{{item.trainingFrequency}}</span>
              </p>
              <p style="display:flex;align-items: center;justify-content: flex-end;padding:0 10px;">
                <el-button size="mini" type="text" v-has="'course_type_update'"  icon="el-icon-edit" @click="edit(item)" style="padding-right:20px;">编辑</el-button>
                <el-switch
                    v-has="'course_switch'" 
                    v-model="item.isDelete == 1 ? false : true"
                    active-color="#13ce66"
                    inactive-color="#eeeeee"
                    active-text="上架"
                    inactive-text="下架"
                    @change="updatesw(index, item.id, item.isDelete)"
                  >
                  </el-switch>
              </p>
            </dt>
          </dl>
        </div>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialog" width="60%" top="50px">
      <div>
          <div class="list-group">
            <el-row :gutter="20">
              <el-col :span="3">
                <div class="list-title"><span class="mast-icon" v-if="modelList.name.request">*</span>{{ modelList.name.name }}:</div>
              </el-col>
              <el-col :span="9">
                <el-input v-model="modelList.name.value" :placeholder="modelList.name.placeholder"></el-input>
              </el-col>
            </el-row>
          </div> 
          <div class="list-group">
            <el-row :gutter="20">
              <el-col :span="3">
                <div class="list-title"><span class="mast-icon" v-if="modelList.targetId.request">*</span>{{ modelList.targetId.name }}:</div>
              </el-col>
              <el-col :span="21">
                <el-radio-group v-model="modelList.targetId.value" :disabled="disabled" @change="targetIdChage">
                  <el-radio :label="item.val" v-for="item in modelList.targetId.optionList" :key="item.val">{{item.name}}</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </div>
          <div class="list-group" v-if="bodyPartsShow">
            <el-row :gutter="20">
              <el-col :span="3">
                <div class="list-title"><span class="mast-icon" v-if="modelList.bodyParts.request">*</span>{{ modelList.bodyParts.name }}:</div>
              </el-col>
              <el-col :span="21">
                <el-radio-group v-model="modelList.bodyParts.value" :disabled="disabled">
                  <el-radio :label="item.val" v-for="item in modelList.bodyParts.optionList" :key="item.val">{{item.name}}</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </div>
          <div class="list-group" v-if="loseWeightShow">
            <el-row :gutter="20">
              <el-col :span="3">
                <div class="list-title"><span class="mast-icon" v-if="modelList.loseWeight.request">*</span>{{ modelList.loseWeight.name }}:</div>
              </el-col>
              <el-col :span="21">
                <el-radio-group v-model="modelList.loseWeight.value" :disabled="disabled">
                  <el-radio :label="item.val" v-for="item in modelList.loseWeight.optionList" :key="item.val">{{item.name}}</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </div> 
          <div class="list-group">
            <el-row :gutter="20">
              <el-col :span="3">
                <div class="list-title"><span class="mast-icon" v-if="modelList.sportsKindId.request">*</span>{{ modelList.sportsKindId.name }}:</div>
              </el-col>
              <el-col :span="21">
                <el-radio-group v-model="modelList.sportsKindId.value" :disabled="disabled">
                  <el-radio :label="item.val" v-for="item in modelList.sportsKindId.optionList" :key="item.val">{{item.name}}</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </div>
          <div class="list-group">
            <el-row :gutter="20">
              <el-col :span="3">
                <div class="list-title"><span class="mast-icon" v-if="modelList.trainingCycle.request">*</span>{{ modelList.trainingCycle.name }}:</div>
              </el-col>
              <el-col :span="21">
                <el-radio-group v-model="modelList.trainingCycle.value" :disabled="disabled">
                  <el-radio :label="item.val" v-for="item in modelList.trainingCycle.optionList" :key="item.val">{{item.name}}</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </div>
          <div class="list-group">
            <el-row :gutter="20">
              <el-col :span="3">
                <div class="list-title"><span class="mast-icon" v-if="modelList.trainingFrequency.request">*</span>{{ modelList.trainingFrequency.name }}:</div>
              </el-col>
              <el-col :span="9">
                <el-input-number v-model="modelList.trainingFrequency.value" :disabled="disabled" :min="1" :max="200"></el-input-number>
              </el-col>
            </el-row>
          </div>
          <div class="list-group">
            <el-row :gutter="20">
              <el-col :span="3">
                <div class="list-title"><span class="mast-icon" v-if="modelList.cover.request">*</span>{{ modelList.cover.name }}:</div>
              </el-col>
              <el-col :span="9">
                <el-input v-model="modelList.cover.value" placeholder style="width:40%"></el-input>
                <img-upload :img-url.sync="modelList.cover.value"></img-upload>
                <p style="font-sise:12px;color:red;">图片规格：690x388</p>
              </el-col>
            </el-row>
          </div>
          <div class="list-group">
                  <el-row :gutter="20">
                      <el-col :span="3">
                          <div class="list-title"><span class="mast-icon" v-if="modelList.introduce.request">*</span>{{ modelList.introduce.name }}:</div>
                      </el-col>
                      <el-col :span="21">
                          <el-input
                              type="textarea"
                              :row="6"
                              v-model="modelList.introduce.value"
                              :placeholder="modelList.introduce.placeholder"
                          ></el-input>
                      </el-col>
                  </el-row>
              </div>
          <div class="list-group" style="display: flex; flex-direction: row; justify-content: center; margin-top: 40px">
            <el-button size="medium" @click="create(1)" style="margin-right: 40px">取 消</el-button>
            <el-button size="medium" type="primary" @click="create(2)">确 定</el-button>
          </div>
	    </div>
    </el-dialog>
  </div>
</template>

<script>
import GalleryModel from '@/components/GalleryModel';
import ImgUpload from '@/components/ImgUpload';
export default {
  components: {ImgUpload,GalleryModel},
  mounted() {
    this.init();
  },
  data() {
    return {
      galleryModelShow:false,
      dialog:false,
      disabled:false,
      bodyPartsShow:false,
      loseWeightShow:true,
      dialogTitle:'新增计划',
      activeName: "-1",
      modelList: {
          name: { value: '', request: true, name: '训练计划名称', placeholder: '请输入训练计划名称', type: 'input' },
          bodyParts: { value: 1, request: false, name: '训练部位', placeholder: '请输入选择训练部位', type: 'input',optionList:[
            {val:1,name:'全身'},{val:2,name:'肩膀'},{val:3,name:'后背'},{val:4,name:'腰腹'},{val:5,name:'腿部'}
          ]},
          loseWeight: { value: 1, request: false, name: '训练斤数', placeholder: '请输入训练斤数', type: 'input',optionList:[
            {val:1,name:'1斤'},{val:2,name:'2斤'},{val:3,name:'3斤'},{val:4,name:'4斤'},{val:5,name:'5斤'},{val:8,name:'8斤'},{val:10,name:'10斤'},{val:15,name:'15斤'}
          ]},
          sportsKindId: { value: 1, request: true, name: '运动类型', placeholder: '请选择运动类型', type: 'input',optionList:[
            {val:1,name:'单车'},{val:2,name:'跑步机'},{val:3,name:'椭圆机'},{val:4,name:'划船机'},{val:5,name:'其它'}
          ]},
          targetId: { value: 1, request: true, name: '训练目标', placeholder: '请选择训练目标', type: 'input',optionList:[
            {val:1,name:'全身/局部变瘦'},{val:2,name:'塑型'},{val:3,name:'保持良好状态'},{val:4,name:'没想好'}
          ]},
          trainingCycle: { value: 1, request: true, name: '训练周期', placeholder: '请选择训练周期', type: 'input' ,optionList:[
            {val:1,name:'一周'},{val:2,name:'二周'},{val:3,name:'三周'},{val:4,name:'一个月'},{val:8,name:'两个月'},{val:12,name:'三个月'}
          ]},
          trainingFrequency:{ value: 0, request: true, name: '训练频次', placeholder: '请上传训练计划封面', type: 'input' },
          cover: { value: '', request: true, name: '训练计划封面', placeholder: '请上传训练计划封面', type: 'input' },
          introduce: { value: '', request: true, name: '训练计划介绍', placeholder: '请输入训练计划介绍', type: 'input' }
      },
      headers: {
        xqiao_token: localStorage.getItem("token"),
      },
      cur: -1,
      selData: [{val:0,name:'全部'},{val:1,name:'单车'},{val:2,name:'跑步机'},{val:3,name:'椭圆机'},{val:4,name:'划船机'},{val:5,name:'其它'}],
      selData1: [{val:0,name:'全部'},{val:1,name:'全身/局部变瘦'},{val:2,name:'塑型'},{val:3,name:'保持良好状态'},{val:4,name:'没想好'}],
      tableData: [],
      switchvalue: true,
      sportsKindId: 0,
      targetId: 0,
      id:''
    };
  },
  filters:{
    trainingCycleName:function(val,list){
      let name=''
      list.forEach(item => {
        if(item.val == val)name=item.name;
      });
      return name;
    },
    targetIdName:function(val,list){
      let name='';
      list.forEach(item => {
        if(item.val == val)name=item.name;
      });
      return name;
    }
  },
  methods: {
    targetIdChage(e){
      console.log(e);
      if(e == 1){
        this.bodyPartsShow=false;
        this.loseWeightShow=true;
      }else if(e == 2){
        this.bodyPartsShow=true;
        this.loseWeightShow=false;
      }else{
        this.bodyPartsShow=false;
        this.loseWeightShow=false;
      }
    },
    choiceImg(e){
      console.log(e);
      this.modelList.cover.value=e.coverUrl;
    },
    //初始化表格数据
    init() {
      //let params = this.searchForm
      this.$get("/plan/package/list", {
        sportsKindId: this.sportsKindId == 0?'':this.sportsKindId,
        targetId: this.targetId== 0?'':this.targetId,
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.tableData = Array.isArray(res.data) ? res.data : [];
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
          return false;
        }
      });
    },
    topnav(e, id) {
      let index = Number(this.activeName);
      this.sportsKindId =
        index === -1
          ? 0
          : Array.isArray(this.selData) && this.selData.length > 0
          ? this.selData[index].id
          : 0;
      this.cur = index;
      this.init();
    },
    add() {
        this.modelList.bodyParts.value=1;
        this.modelList.cover.value='';
        this.modelList.introduce.value='';
        this.modelList.loseWeight.value=1;
        this.modelList.name.value='';
        this.modelList.sportsKindId.value=1;
        this.modelList.targetId.value=1;
        this.modelList.trainingCycle.value=1;
        this.modelList.trainingFrequency.value=1;
        this.queryType=1;
        this.id='';
        this.dialog=true;
        this.disabled=false;
        this.dialogTitle='新增计划';
    },
    edit(data){
      console.log(data);
        this.modelList.bodyParts.value=data.bodyParts;
        this.modelList.cover.value=data.cover;
        this.modelList.introduce.value=data.introduce;
        this.modelList.loseWeight.value=data.loseWeight;
        this.modelList.name.value=data.name;
        this.modelList.sportsKindId.value=data.sportsKindId;
        this.modelList.targetId.value=data.targetId;
        this.modelList.trainingCycle.value=data.trainingCycle;
        this.modelList.trainingFrequency.value=data.trainingFrequency;
        this.queryType=2;
        this.id=data.id;
        this.dialog=true;
        this.disabled=true;
        this.dialogTitle='编辑计划';
    },
    updatesw(index, id, status) {
      if (!id) return this.$message.error("计划列表错误");
      const url = status == 1 ? "/plan/package/open" : "/plan/package/close";
      const loading = this.$loading({ text: "加载中..." });
      this.$post(url, { planPackageId: id })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.tableData[index].isDelete = status == 1 ? 0 : 1;
          } else {
            this.$message.error(JSON.stringify(res.message));
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error(JSON.stringify(err));
          loading.close();
        });
    },
    create(flag){
			if (flag == 1) {
          this.dialog=false;
				  return false;
        }
	    	let test = this.testMethod();
        if (!test.flag) {
            this.$message.error(test.msg);
            return false;
        }
			  let url=this.queryType==1?'/plan/package/create':'/plan/package/update';
        const loading = this.$loading({ text: "加载中..." });
        this.$post(url, test.data).then((res) => {
            if (res.code == 0) {
              this.$message.success("操作成功");
              this.dialog=false;
              this.init()
            } else {
              this.$message.error(JSON.stringify(res.message));
            }
            loading.close();
        }).catch(err=>{
            this.$message.error(JSON.stringify(err));
            loading.close();
        })
	    },
		//验证方法
        testMethod() {
            let flag = true,
                msg = '',
                data = {};
            for (let i in this.modelList) {
                if (this.modelList[i].request) {
                    if (!this.modelList[i].value || this.modelList[i].value == '') {
                        flag = false;
                        msg = this.modelList[i].placeholder;
                        break;
                    }
                }
            }
            if(flag){
                data = {
                    bodyParts: this.modelList.bodyParts.value,
                    cover: this.modelList.cover.value,
                    introduce: this.modelList.introduce.value,
                    loseWeight: this.modelList.loseWeight.value,
                    name: this.modelList.name.value,
                    sportsKindId: this.modelList.sportsKindId.value,
                    targetId: this.modelList.targetId.value,
                    trainingCycle: this.modelList.trainingCycle.value,
                    trainingFrequency: this.modelList.trainingFrequency.value
                };
                if(this.queryType == 2){
                    data.planPackageId=this.id;
                }
            }
            return { flag: flag, msg: msg,data:data };
        },
    // 路由跳转
    addTrainingPlan(id) {
      this.$router.push({
        path: "/addTrainingPlan",
        query: { type: 2, id: id },
      });
    },
  },
};
</script>

<style scoped>
.traingplan {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.traingplan .traingplan-group {
  width: 20%;
  padding:10px;
  box-sizing: border-box;
}
.traingplan dt {
  background: #ffffff;
  box-shadow: 0 12px 20px 0 rgba(0,0,0,.2);
  border-radius: 6px;
  overflow: hidden;
  font-size: 0;
}
.traingplan dt:hover{
  cursor: pointer;
  box-shadow:
   1px 1px 8px 4px rgba(0, 0, 0, 0.4);
}
.traingplan dl img {
  width: 100%;
  height: 160px;
  object-fit:cover
}
.traingplan dd {
  margin-top: 5px;
  font-size: 13px;
}
.title{
  font-size: 14px;
  color:#333;
  font-weight: bold;
  padding:8px;
}
.title_bewteen{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.el-switch {
  float: right;
}
.traingplan-img-group{
  position: relative;
}
.traingplan-img-group:hover .traingplan-hover{
  display: flex;
}
.traingplan-hover{
  position: absolute;
  top:0;
  left:0;
  bottom:0;
  right: 0;
  display: none;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,.6);
  font-size: 16px;
  color:#fff;
}
</style>




// WEBPACK FOOTER //
// src/views/coursesList/trainingPlan/index.vue